import { combineReducers } from "redux";
import reducer from "../common";

export default combineReducers({
  countries: reducer("GET_COUNTRIES", []),
  states: reducer("GET_STATES", []),
  cities: reducer("GET_CITIES", []),
});
